// module for saving tokens to local storage
const TOKEN_KEY = "stampTokens";
const GUEST_TOKEN_KEY = "guestStampTokens";
const IS_GUEST_USER_AUTHENTICATED = "isGuestUserAuthenticated";
// tokens = { accessToken: "xyz", refreshToken: "abc" }
export function saveTokens(tokens) {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens));
}

export function getTokens() {
  return JSON.parse(localStorage.getItem(TOKEN_KEY));
}

export function deleteTokens() {
  localStorage.removeItem(TOKEN_KEY);
}

export function saveLogin(key, value) {
  localStorage.setItem(key, value);
}

export function getLogin(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function deleteLogin(key) {
  localStorage.removeItem(key);
}

export function checkLogin(key) {
  if (!localStorage.getItem(key)) {
    return false;
  } else {
    return true;
  }
}

export function getGuestTokens() {
  return JSON.parse(sessionStorage.getItem(GUEST_TOKEN_KEY));
}
export function saveGuestTokens(token) {
  sessionStorage.setItem(GUEST_TOKEN_KEY, JSON.stringify(token));
}

export function saveGuestLogin(value) {
  sessionStorage.setItem(IS_GUEST_USER_AUTHENTICATED, value);
}

export function getGuestLogin() {
  return JSON.parse(sessionStorage.getItem(IS_GUEST_USER_AUTHENTICATED));
}

export function logoutGuestUser() {
  saveGuestLogin(false);
  sessionStorage.removeItem(GUEST_TOKEN_KEY);
}
